import { WS_EVENT, WS_EVENT_SHOP_STATE, WS_EVENT_FLAGS } from '@/constants/socketEvent'

export const handleShareClick = ({ socket }: any) => {
  const content = {
    sid: WS_EVENT_SHOP_STATE.sid,
    ssid: WS_EVENT_SHOP_STATE.state,
    flags: WS_EVENT_FLAGS.Broadcast,
    body: {
      type: WS_EVENT.SHARE,
      from: {
        name: 'test111',
        head_url: 'http://xxxx',
        role: 11,
      },
    },
  }

  socket.emit('CHANNEL', JSON.stringify(content))
}
